import Ekskul from "../../../../../components/categories/siakad/lms/data_ekskul/Home";
export default function Home() {
  
  return (
    <Ekskul />
  );
}
